import { buildDemandeService } from '../buildDemandeService'
import type { ContratProADTO, FormationDTO, LovProADTO } from '@/features/api/extranet/dto/Demande/PROA'
import { EndPointsFormationDemandeProa } from '@/features/services'

export default buildDemandeService<"MODEL_PROA", LovProADTO>({
  location: EndPointsFormationDemandeProa.location,
  normaliserData,
})

function normaliserData(data: ContratProADTO) {
  //data.typeDemande ??= TypeDemandeDossier
  data.fichiers ??= []

  data.employeur ??= ({} as any)
  data.employeur!.contact ??= ({} as any)
  data.employeur!.etablissement ??= ({} as any)
  data.employeur!.etablissement!.adresse ??= ({} as any)

  data.salarie ??= ({} as any)
  data.salarie!.adresse ??= ({} as any)
  data.salarie!.source ??= 'Portail'

  data.tutorat ??= ({} as any)
  data.tutorat!.tuteurEntrepriseEmployeur ??= ({} as any)
  data.tutorat!.tuteurEntrepriseUtilisatrice ??= ({} as any)

  data.contrat ??= ({} as any)
  data.contrat!.dureeHebdomadaire ??= ({} as any)
  data.formation ??= ({} as FormationDTO)
  data.formation.modules ??= []
  data.financement ??= {}

  /*

  data.formation.referenceFormationInterneEntreprise = data.formation.referenceFormationInterneEntreprise ?? null
  data.formation.typeQualification = data.formation.typeQualification ?? TypeQualification.Rncp
  data.formation.rncp = data.formation.rncp ?? ({} as RncpDto)
  data.formation.formacode = data.formation.formacode ?? ({} as FormacodeDTO)
  data.formation.nsf = data.formation.nsf ?? null
  data.formation.diplome = data.formation.diplome ?? null
  data.formation.dureeEnseignement = data.formation.dureeEnseignement ?? null

  */
  return data
}
